export default __webpack_public_path__ + "static/media/button-spinner.28f3ba63.svg";